import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Appointment2Model, AppointmentOption, Guest, Place} from '../../../appointments/models/appointment.model';
import {CalendarService} from '../../../calendar/services/calendar.service';
import {CalendarFilterModel} from '../../../calendar/models/calendar-filter.model';
import {DateUtilities} from '../../utilities/date-utilities.model';
import {CalendarModel, CalendarModelI} from '../../../calendar/models/calendar.model';
import {Utilities} from '../../utilities/utilities.model';
import {Appointments2} from '../../../appointments/models/appointments.model';
import {AppointmentPlannedModel, Availability} from '../../../contract-closing-commons/models/appointment-planned.model';
import {Appointments2FilterModel} from '../../../appointments/models/appointments2-filter.model';
import {Appointments2Service} from '../../../appointments/services/appointments2.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'amd-cc-select-data-for-appointment-table',
    templateUrl: './cc-select-data-for-appointment-table.component.html',
    styleUrls: ['./cc-select-data-for-appointment-table.component.scss']
})
export class CcSelectDataForAppointmentTableComponent implements OnInit, OnChanges {

    @Input() centerSelected: Place;
    @Input() needRefresh: boolean;
    @Input() isDelivery: boolean;
    items: CalendarModel[];
    events = new Map<string, CalendarModel[]>();
    appointmentPlannedModel: AppointmentPlannedModel[] = [];
    elementsToShow = 20;
    disableShoMore = false;
	responseCalendarIsVoid: boolean;
	tableForDeliveryIsPresent = false;
	lastCenterSelected: string;
	appointmentsForDelivery: AppointmentPlannedModel[] = [];
	translateContext = TranslateContext;

    constructor(private calendarService: CalendarService,
				private appointments2Service: Appointments2Service) {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
    	if (!Utilities.isVoid(changes.isDelivery)) {
    		this.checkTableForAppointmentsDelivery();
		}
        if (!Utilities.isVoid(changes.centerSelected) && !Utilities.isVoid(this.centerSelected) && !Utilities.isVoid(this.centerSelected.name)) {
			this.checkTableForAppointmentsDelivery();
            let calendarFilterModel: CalendarFilterModel;
            let filterAppointments: Appointments2FilterModel;
			this.responseCalendarIsVoid = false;

            if (!Utilities.isVoid(this.centerSelected)) {
				if (!Utilities.isVoid(this.centerSelected.has_dedicated_expert) && !this.centerSelected.has_dedicated_expert) {
					calendarFilterModel = new CalendarFilterModel();
					calendarFilterModel.datetime_from = DateUtilities.getUTCStringFromDate(DateUtilities.getNow());
					calendarFilterModel.datetime_to = DateUtilities.getUTCStringFromDate(DateUtilities.newerUtcDate);
					calendarFilterModel.place_ald_commodity_id = this.centerSelected.ald_commodity_id;
					calendarFilterModel.type = [Appointment2Model.APPOINTMENT_TYPE_CLOSING, Appointment2Model.APPOINTMENT_TYPE_EXCHANGE_1, Appointment2Model.APPOINTMENT_TYPE_EXCHANGE_2];

					filterAppointments = new Appointments2FilterModel();
					filterAppointments.date_from = DateUtilities.getUTCStringFromDate(DateUtilities.getNow());
					filterAppointments.date_to = DateUtilities.getUTCStringFromDate(DateUtilities.newerUtcDate);
					filterAppointments.ald_supplier_id = this.centerSelected.ald_commodity_id;
					// filterAppointments.status = Appointment2Model.STATUS_PLANNED;
					filterAppointments.asc = true;
				} else if (!Utilities.isVoid(this.centerSelected.has_dedicated_expert) && this.centerSelected.has_dedicated_expert)  {
					calendarFilterModel = new CalendarFilterModel();
					calendarFilterModel.datetime_from = DateUtilities.getUTCStringFromDate(DateUtilities.getNow());
					calendarFilterModel.datetime_to = DateUtilities.getUTCStringFromDate(DateUtilities.newerUtcDate);
					calendarFilterModel.place_ald_commodity_id = this.centerSelected.ald_commodity_id;
					calendarFilterModel.type = [CalendarModel.AVAILABILITY];

					filterAppointments = new Appointments2FilterModel();
					filterAppointments.date_from = DateUtilities.getUTCStringFromDate(DateUtilities.getNow());
					filterAppointments.date_to = DateUtilities.getUTCStringFromDate(DateUtilities.newerUtcDate);
					// filterAppointments.status = Appointment2Model.STATUS_PLANNED;
					filterAppointments.ald_supplier_id = this.centerSelected.ald_commodity_id;
					filterAppointments.asc = true;
				}
				this.calendarService.getListForTable(calendarFilterModel, filterAppointments).subscribe(
					(results) => {
						if (!Utilities.isVoid(results[0]) && !Utilities.isVoid(results[1])) {
							const calendarModel: CalendarModelI[] = results[0].json().items;
							if (Utilities.isVoid(calendarModel) || calendarModel.length === 0) {
								this.responseCalendarIsVoid = true;
							}
							const appointment2: Appointments2 = new Appointments2(results[1].json());
							if (!Utilities.isVoid(calendarModel) && !Utilities.isVoid(appointment2)) {
								const appointmentPlanned = (appointment2.items as Appointment2Model[]).filter(a => a.status === Appointment2Model.STATUS_PLANNED);
								const appointmentPlanning = (appointment2.items as Appointment2Model[]).filter(a => a.status === Appointment2Model.STATUS_PLANNING || a.status === Appointment2Model.STATUS_PLANNING_HIDDEN);
								const arrayOfOptions: AppointmentOption[] = [];
								for (const appPlanning of appointmentPlanning) {
									for (const option of appPlanning.options) {
										arrayOfOptions.push(option);
									}
								}
								this.appointmentPlannedModel = [];
								for (const calendarEvents of calendarModel) {
									const appointments = (appointmentPlanned).filter(date => {
											return DateUtilities.compareDateIsSame(DateUtilities.getDate(DateUtilities.getDate(date.datetime_confirmed).setHours(0, 0, 0, 0)),
                                                DateUtilities.getDate(DateUtilities.getDate(calendarEvents.datetime_start).setHours(0, 0, 0, 0)))
										}
									);
									let isValid = true;
									if (!this.centerSelected.has_dedicated_expert) {
									    const dateISPresent = this.appointmentPlannedModel.filter(d =>
											DateUtilities.getDate(d.date).setHours(0, 0, 0, 0)
                                             === DateUtilities.getDate(calendarEvents.datetime_start).setHours(0, 0, 0, 0));
									    if (dateISPresent.length > 0) {
									        isValid = false;
                                        }
                                    }

                                    if (isValid) {
										const item = {} as AppointmentPlannedModel;
										item.date = calendarEvents.datetime_start;
										const dates: Date[] = appointments.length > 0 ? appointments.map(date => DateUtilities.getDate(date.datetime_confirmed)) : [];
										if (dates.length > 0 ) {
											dates.sort();
										}
										const a: string[] = [];
										for (const d of dates) {
											a.push(DateUtilities.getUTCStringFromDate(d));
										}
										item.appointmentsPlanned = a;
										item.availability = [calendarEvents.datetime_start, calendarEvents.datetime_end];
										item.options = {am: 0 , pm: 0, fullDay: 0};
										this.appointmentPlannedModel.push(item);
                                    }

								}
								for (const option of arrayOfOptions) {
									const dateIsPresent = this.appointmentPlannedModel.filter(date => {
										return DateUtilities.compareDateIsSame(DateUtilities.getDate(DateUtilities.getDate(option.date).setHours(0, 0, 0, 0)),
											DateUtilities.getDate(DateUtilities.getDate(date.date).setHours(0, 0, 0, 0)))
									});
									if (!Utilities.isVoid(dateIsPresent) && dateIsPresent.length > 0) {
										const index = this.appointmentPlannedModel.indexOf(dateIsPresent[0]);
										switch (option.time_slot) {
											case Appointment2Model.TIME_SLOT_AM:
												this.appointmentPlannedModel[index].options.am = this.appointmentPlannedModel[index].options.am + 1;
												break;
											case Appointment2Model.TIME_SLOT_PM:
												this.appointmentPlannedModel[index].options.pm = this.appointmentPlannedModel[index].options.pm + 1;
												break;
											case Appointment2Model.TIME_SLOT_FULL_DAY:
												this.appointmentPlannedModel[index].options.fullDay = this.appointmentPlannedModel[index].options.fullDay + 1;
												break;
										}

									} else {
										const newDate: AppointmentPlannedModel = {} as AppointmentPlannedModel;
										newDate.date = option.date;
										newDate.appointmentsPlanned = [];
										newDate.options = {am: 0 , pm: 0, fullDay: 0};
										switch (option.time_slot) {
											case Appointment2Model.TIME_SLOT_AM:
												newDate.options.am = newDate.options.am + 1;
												break;
											case Appointment2Model.TIME_SLOT_PM:
												newDate.options.pm = newDate.options.pm + 1;
												break;
											case Appointment2Model.TIME_SLOT_FULL_DAY:
												newDate.options.fullDay = newDate.options.fullDay + 1;
												break;
										}
										this.appointmentPlannedModel.push(newDate);
									}
								}

								this.appointmentPlannedModel.sort(function(a, b) {
									return DateUtilities.getDate(a.date).getTime() - DateUtilities.getDate(b.date).getTime();
								});

								if (this.elementsToShow <= this.appointmentPlannedModel.length) {
                                    this.disableShoMore = true;
                                }
							} else {
								//TODO error message non e' stato possibile recuperare la lista di appuntamtni programmati
							}
						}

					}, error1 => {
					}
                );
            }
        }
    }


	checkTableForAppointmentsDelivery() {
    	if (!Utilities.isVoid(this.centerSelected) && !Utilities.isVoid(this.centerSelected.ald_commodity_id) && this.isDelivery) {
    		if (Utilities.isVoid(this.lastCenterSelected)) {
				this.lastCenterSelected = this.centerSelected.ald_commodity_id;
			}
    		if (!this.tableForDeliveryIsPresent || this.lastCenterSelected !== this.centerSelected.ald_commodity_id) {
				this.createTableForAppointmentsDelivery();
			}
		}
    	if (!this.isDelivery) {
    		this.appointmentsForDelivery = [];
		}
	}

	createTableForAppointmentsDelivery() {
    	if (this.isDelivery) {
    		this.tableForDeliveryIsPresent = true;
    		const filter: Appointments2FilterModel = new Appointments2FilterModel();
    		filter.status = '' + Appointment2Model.STATUS_PLANNED + ',' + Appointment2Model.STATUS_PLANNING;
    		filter.ald_supplier_id = this.centerSelected.ald_commodity_id;
    		filter.type = [Appointment2Model.APPOINTMENT_TYPE_DELIVERY];
			filter.date_from = DateUtilities.getUTCStringFromDate(DateUtilities.getNow());
			filter.date_to = DateUtilities.getUTCStringFromDate(DateUtilities.newerUtcDate);
			filter.asc = true;
			this.appointments2Service.getList(filter).subscribe(
				listOfAppointments =>  {
					if (!Utilities.isVoid(listOfAppointments) && !Utilities.isVoid(listOfAppointments.items)) {
						const appointmentPlanned = (listOfAppointments.items as Appointment2Model[]).filter(a => a.status === Appointment2Model.STATUS_PLANNED);
						const appointmentPlanning = (listOfAppointments.items as Appointment2Model[]).filter(a => a.status === Appointment2Model.STATUS_PLANNING);
						const arrayOfOption: AppointmentOption[] = [];
						for (const appPlanning of appointmentPlanning) {
							for (const option of appPlanning.options) {
								arrayOfOption.push(option);
							}
						}
						this.appointmentsForDelivery = [];
						for (const app of appointmentPlanned) {
								const dateIsPresent = this.appointmentsForDelivery.filter(date => {
									return DateUtilities.compareDateIsSame(DateUtilities.getDate(DateUtilities.getDate(app.datetime_confirmed).setHours(0, 0, 0, 0)),
										DateUtilities.getDate(DateUtilities.getDate(date.date).setHours(0, 0, 0, 0)))
								});
								if (!Utilities.isVoid(dateIsPresent) && dateIsPresent.length > 0) {
									const index = this.appointmentsForDelivery.indexOf(dateIsPresent[0]);
									this.appointmentsForDelivery[index].appointmentsPlanned.push(app.datetime_confirmed);
								} else {
									const item = {} as AppointmentPlannedModel;
									item.date = app.datetime_confirmed;
									item.appointmentsPlanned = [app.datetime_confirmed];
									item.availability = null;
									item.options = {am: 0 , pm: 0, fullDay: 0};
									this.appointmentsForDelivery.push(item);
								}
						}

						for (const option of arrayOfOption) {
							const dateIsPresent = this.appointmentsForDelivery.filter(date => {
								return DateUtilities.compareDateIsSame(DateUtilities.getDate(DateUtilities.getDate(option.date).setHours(0, 0, 0, 0)),
									DateUtilities.getDate(DateUtilities.getDate(date.date).setHours(0, 0, 0, 0)))
							});
							if (!Utilities.isVoid(dateIsPresent) && dateIsPresent.length > 0) {
								const index = this.appointmentsForDelivery.indexOf(dateIsPresent[0]);
								switch (option.time_slot) {
									case Appointment2Model.TIME_SLOT_AM:
										this.appointmentsForDelivery[index].options.am = this.appointmentsForDelivery[index].options.am + 1;
										break;
									case Appointment2Model.TIME_SLOT_PM:
										this.appointmentsForDelivery[index].options.pm = this.appointmentsForDelivery[index].options.pm + 1;
										break;
									case Appointment2Model.TIME_SLOT_FULL_DAY:
										this.appointmentsForDelivery[index].options.fullDay = this.appointmentsForDelivery[index].options.fullDay + 1;
										break;
								}

							} else {
								const newDate: AppointmentPlannedModel = {} as AppointmentPlannedModel;
								newDate.date = option.date;
								newDate.appointmentsPlanned = [];
								newDate.options = {am: 0 , pm: 0, fullDay: 0};
								switch (option.time_slot) {
									case Appointment2Model.TIME_SLOT_AM:
										newDate.options.am = newDate.options.am + 1;
										break;
									case Appointment2Model.TIME_SLOT_PM:
										newDate.options.pm = newDate.options.pm + 1;
										break;
									case Appointment2Model.TIME_SLOT_FULL_DAY:
										newDate.options.fullDay = newDate.options.fullDay + 1;
										break;
								}
								this.appointmentsForDelivery.push(newDate);
							}
						}

						this.appointmentsForDelivery.sort(function(a, b) {
							return DateUtilities.getDate(a.date).getTime() - DateUtilities.getDate(b.date).getTime();
						});

					}
				}, error => {
				});
		}
	}

    showMore() {
		this.elementsToShow += 10;
        if (this.elementsToShow >= this.appointmentPlannedModel.length) {
			this.disableShoMore = true;
        }
    }
}
